export const storeAccountList = (state, accountList) => {
  state.accountList = [...accountList];
};

export const storeAccount = (state, account) => {
  state.account = { ...account };
};
